// extracted by mini-css-extract-plugin
export var smallSpinner = "_sj-0";